<div id="navbar-mobile-menu" >
  <ul id="navbar-mobile-main-menu">
    <li class="menu-item" [ngClass]="{'selected-section': isSectorOpen, '': !isSectorOpen}">
        <div class="main-menu-content">
            <div class="main-menu-title" (click)="toggleSection('sectors')">
                <span>
                    Sectores
                </span>
                <fa-icon [icon]="isSectorOpen ? 'chevron-up' : 'chevron-down'"></fa-icon>

            </div>
            @if (isSectorOpen) {
                <ul class="secondary-menu-container" >
                    <li class="menu-item"><a href="/sectors/public-security" (click)="closeDropdown()">Seguridad pública</a></li>
                    <li class="menu-item"><a href="/sectors/private-security" (click)="closeDropdown()">Seguridad privada</a></li>
                    <li class="menu-item"><a href="/sectors/inspections" (click)="closeDropdown()">Inspecciones</a></li>
                </ul>
            }
        </div>
    </li>
    <li class="menu-item" [ngClass]="{'selected-section': isProductsOpen, '': !isProductsOpen}">
        <div class="main-menu-content">
            <div class="main-menu-title" (click)="toggleSection('products')">
                <span>
                    Productos
                </span>
                <fa-icon [icon]="isProductsOpen ? 'chevron-up' : 'chevron-down'"></fa-icon>
            </div>
            @if (isProductsOpen) {
                <ul class="secondary-menu-container">
                    <li class="menu-item"><a href="/products/matrice-400" (click)="closeDropdown()">Matrice 400</a></li>
                    <li class="menu-item"><a href="/products/matrice-4" (click)="closeDropdown()">Matrice 4</a></li>
                    <li class="menu-item"><a href="/products/dock3" (click)="closeDropdown()">Dock 3</a></li>
                    <li class="menu-item"><a href="/products/matrice-4-td" (click)="closeDropdown()">Matrice 4 TD</a></li>
                    <li class="menu-item"><a href="/products/fh2" (click)="closeDropdown()">FlightHub 2</a></li>
                    <li class="menu-item"><a href="/products/terra" (click)="closeDropdown()">Terra</a></li>
                </ul>
            }
        </div>
    </li>
  </ul>
  <div id="navbar-mobile-bottom-menu">
    <div id="navbar-mobile-contact-link">
        <a href="#contact-form-compact-container" (click)="closeDropdown()">
            <span>CONTACTA CON NOSOTROS</span>
        </a>
    </div>
  </div>
</div>
